import React, { useEffect } from "react";
import { Box, Grid, Typography, Paper, Button, TextField, Fade, Collapse } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import usePersonAuthStore from "../../store/personAuthStore"
const passwordTestRegex = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/);

const PasswordExpired = () => {
    const [success, setSuccess] = React.useState(false);
    const [error, setError] = React.useState('');
    const [submitting, setSubmmiting] = React.useState(false);
    const [showError, setShowError] = React.useState(false);
    const { email } = useParams<any>();

    const [newPassword, setNewPassword] = React.useState('')
    const [confirmNewPassword, setConfirmNewPassword] = React.useState('')
    const accessToken = usePersonAuthStore(state => state.access_token);

    const navigate = useNavigate();

    const handleChange = (name: string, value: string) => {
        if (showError) {
            setShowError(false);
        }
        if (name === "newPassword") {
            setNewPassword(value)
        } else {
            setConfirmNewPassword(value)
        }
    }
    useEffect(() => {
        if (success) {
            navigate("/dashboard")
        }
    }, [success])
    React.useEffect(() => {
        if (newPassword === confirmNewPassword) {
            if (!Boolean(passwordTestRegex.test(newPassword) && passwordTestRegex.test(confirmNewPassword))) {
                setError('Your password must be at least 8 characters long, contain at least one number, one special character, and have a mixture of uppercase and lowercase letters.')
                setShowError(true);
            }
        }
    }, [newPassword, confirmNewPassword])

    const handleSend = async () => {
        setSubmmiting(true)
        var data = JSON.stringify({
            "email": email,
            "newPassword": `${newPassword}`,
            "confirmPassword": `${confirmNewPassword}`,
        });
        var config = {
            method: 'post',
            url: `${window.__env.API_URL}/api/oauth/password-expired`,
            headers: {
                'Content-Type': 'application/json',
                authorization: `Bearer ${accessToken}`
            },
            data: data
        };

        //@ts-ignore
        await axios(config).then((res: any) => {
            setSuccess(true);
        })
            .catch(function (error) {
                if (error.response) {
                    const message = JSON.parse(error.request.response)?.message
                    if (message == "New Password cannot match previous") {
                        setError("New password cannot match previous password");
                    } else {
                        setError("This link is invalid. Please request a new link via forgot password");
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    setError("Connection refused. Please try again later");
                } else {
                    // Something happened in setting up the request that triggered an Error
                    setError("Connection refused. Please try again later");
                }
                setSubmmiting(false);
                setShowError(true)
            });
    };


    const renderContent = () => {
        if (!success) {
            return (
                <Grid size={12}>
                    <Grid container spacing={2} style={{ marginTop: "24px", marginBottom: "16px", maxWidth: "400px", margin: "auto" }}>
                        <Grid size={12}>
                            <TextField label="New Password" type="password"
                                value={newPassword}
                                onChange={(e) => handleChange("newPassword", e.target.value)}
                                fullWidth />
                        </Grid>
                        <Grid size={12}>
                            <TextField label="Confirm Password" type="password"
                                value={confirmNewPassword}
                                onChange={(e) => handleChange("confirmNewPassword", e.target.value)}
                                fullWidth />
                        </Grid>
                    </Grid>
                </Grid>
            )
        } else {
            return <Grid size={12}>
                <Typography variant="h6" sx={{ fontWeight: 400 }}>
                    Success!
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 400 }}>
                    We successfully updated your password.
                </Typography>
                <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
                    <Button variant="contained" sx={{ backgroundColor: "#C4C4C4" }} onClick={() => navigate('/login')}>
                        Return to Login Page
                    </Button>
                </div>
            </Grid>
        }
    }
    return <div style={{ height: "100vh", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Fade in={true} timeout={400}>
            <Box component={Paper} sx={{ width: "550px", height: "auto", padding: "24px" }}>
                <Grid container spacing={2} sx={{ display: "flex", alignContent: "space-between", height: "100%" }}>
                    <Grid size={12}>
                        <Typography variant="h4" color="secondary" sx={{ fontWeight: "bold" }}>
                            It has been 90 days since you last updated your password, please provide a new password
                        </Typography>
                    </Grid>

                    <Grid size={12}>
                        <Grid container spacing={2} style={{ marginTop: "24px", marginBottom: "16px", maxWidth: "400px", margin: "auto" }}>
                            <Grid size={12}>
                                <TextField label="New Password" type="password"
                                    value={newPassword}
                                    onChange={(e) => handleChange("newPassword", e.target.value)}
                                    fullWidth />
                            </Grid>
                            <Grid size={12}>
                                <TextField label="Confirm Password" type="password"
                                    value={confirmNewPassword}
                                    onChange={(e) => handleChange("confirmNewPassword", e.target.value)}
                                    fullWidth />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid size={12}>
                        <Collapse in={showError}>
                            <Typography color="error" sx={{ marginTop: "8px", marginBottom: "8px", textAlign: "center" }}>{error}</Typography>
                        </Collapse>
                    </Grid>
                </Grid>
                <Collapse in={!success}>
                    <Grid container spacing={2} sx={{ paddingTop: "8px", justifyContent: "center" }}>
                        {/* <Grid size={6} sx={{ display: "flex", justifyContent: "center" }}>
                            <Button variant="contained" onClick={() => navigate('/login')} sx={{ backgroundColor: "#C4C4C4" }}>
                                Cancel
                            </Button>
                        </Grid> */}
                        <Grid size={6} sx={{ display: "flex", justifyContent: "center" }}>
                            {submitting ? (
                                <LoadingButton
                                    loading={submitting}
                                    variant="contained"
                                >
                                    Submit
                                </LoadingButton>
                            ) : (
                                <Button variant="contained" disabled={Boolean(newPassword.length === 0) || newPassword !== confirmNewPassword || showError} onClick={() => handleSend()}>
                                    Send
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Collapse>
            </Box>
        </Fade>
    </div>
}

export default PasswordExpired;